<template>
  <div>
    <div class="page-header clear-filter" filter-color="orange">
      <parallax
          class="page-header-image"
          style="background-image:url('img/buildings.png')"
      >
      </parallax>
      <div class="container">
        <div class="content-center brand">
          <!--          <img class="n-logo" src="img/now-logo.png" alt="" />-->
          <svg class="n-logo" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
               width="80" height="80"
               viewBox="0 0 172 172"
               style=" fill:#000000;">
            <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
               stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
               font-family="none" font-weight="none" font-size="none" text-anchor="none"
               style="mix-blend-mode: normal">
              <path d="M0,172v-172h172v172z" fill="none"></path>
              <g fill="#ffffff">
                <path
                    d="M86,1.34375c-9.675,0 -17.46875,7.79375 -17.46875,17.46875c0,9.675 7.79375,17.46875 17.46875,17.46875c9.675,0 17.46875,-7.79375 17.46875,-17.46875c0,-9.675 -7.79375,-17.46875 -17.46875,-17.46875zM86,9.40625c5.24063,0 9.40625,4.16563 9.40625,9.40625c0,5.24062 -4.16562,9.40625 -9.40625,9.40625c-5.24062,0 -9.40625,-4.16563 -9.40625,-9.40625c0,-5.24062 4.16563,-9.40625 9.40625,-9.40625zM59.52917,28.92737c-0.78105,-0.05984 -1.58048,0.09816 -2.28595,0.50128l-6.98645,4.03125c-1.88125,1.075 -2.5526,3.6276 -1.4776,5.50885c0.67188,1.34375 2.14948,2.01563 3.49323,2.01563c0.67188,0 1.34375,-0.1349 2.01563,-0.53803l6.98645,-4.03125c1.88125,-1.075 2.5526,-3.6276 1.4776,-5.50885c-0.67187,-1.17578 -1.92114,-1.87915 -3.2229,-1.97888zM112.47083,28.92737c-1.30176,0.09973 -2.55103,0.8031 -3.2229,1.97888c-1.075,1.88125 -0.40365,4.43385 1.4776,5.50885l6.98645,4.03125c0.67188,0.40313 1.34375,0.53803 2.01563,0.53803c1.34375,0 2.68698,-0.67187 3.49323,-2.01562c1.075,-1.88125 0.40365,-4.43385 -1.4776,-5.50885l-6.98645,-4.03125c-0.70547,-0.40313 -1.5049,-0.56112 -2.28595,-0.50128zM25.53125,34.9375c-9.675,0 -17.46875,7.79375 -17.46875,17.46875c0,9.675 7.79375,17.46875 17.46875,17.46875c9.675,0 17.46875,-7.79375 17.46875,-17.46875c0,-9.675 -7.79375,-17.46875 -17.46875,-17.46875zM146.46875,34.9375c-9.675,0 -17.46875,7.79375 -17.46875,17.46875c0,9.675 7.79375,17.46875 17.46875,17.46875c9.675,0 17.46875,-7.79375 17.46875,-17.46875c0,-9.675 -7.79375,-17.46875 -17.46875,-17.46875zM25.53125,43c5.24062,0 9.40625,4.16562 9.40625,9.40625c0,5.24063 -4.16563,9.40625 -9.40625,9.40625c-5.24063,0 -9.40625,-4.16562 -9.40625,-9.40625c0,-5.24063 4.16562,-9.40625 9.40625,-9.40625zM146.46875,43c5.24062,0 9.40625,4.16562 9.40625,9.40625c0,5.24063 -4.16563,9.40625 -9.40625,9.40625c-5.24062,0 -9.40625,-4.16562 -9.40625,-9.40625c0,-5.24063 4.16563,-9.40625 9.40625,-9.40625zM86,49.71875c-20.69375,0 -37.625,16.93125 -37.625,37.625c0,20.69375 16.93125,37.625 37.625,37.625c20.69375,0 37.625,-16.93125 37.625,-37.625c0,-20.69375 -16.93125,-37.625 -37.625,-37.625zM86,57.78125c4.03125,0 7.79428,0.8052 11.28803,2.28333v2.1521c0,1.6125 -0.94115,3.2229 -2.55365,3.89478c-3.35937,1.47813 -6.71822,0.6724 -8.19635,4.56927c-1.075,2.82188 2.01457,10.75 5.6427,10.75c4.70313,0 6.98907,-9.5401 8.33282,-9.5401c0.94063,0 2.28228,2.82083 3.89478,4.97083c1.075,1.47813 2.82187,2.28595 4.70313,2.28595h3.09167l2.01563,0.53802c0.94062,2.28438 1.34375,4.97083 1.34375,7.65833c0,16.25937 -13.30313,29.5625 -29.5625,29.5625c-4.97187,0 -9.67605,-1.20938 -13.84167,-3.35937h0.13647c1.075,-0.67187 2.28385,-1.34322 3.49323,-2.14947c0.94062,-0.67187 1.61197,-1.4797 2.14947,-2.28595c0.67188,-1.075 1.3448,-2.28333 1.74792,-3.62708c2.41875,-9.1375 -5.51042,-9.5401 -5.77917,-11.55572c-0.26875,-2.28438 2.68855,-3.89793 4.43542,-5.77918c1.74688,-1.88125 2.28438,-4.56822 1.34375,-6.18072c-2.95625,-5.24062 -9.9448,-2.55208 -10.4823,3.09167c-0.40313,3.35938 -2.41822,6.85155 -4.1651,8.46405c-1.74687,1.74688 -5.10625,0.80782 -6.04687,-1.7453c-1.075,-2.82187 2.55312,-3.89688 2.01563,-7.39062c-0.13438,-0.94062 -1.21043,-1.4797 -2.4198,-1.61407l-2.01562,0.13385c2.41875,-14.24375 14.6474,-25.12708 29.42865,-25.12708zM25.53125,77.9375c-2.28438,0 -4.03125,1.74688 -4.03125,4.03125v8.0625c0,2.28437 1.74687,4.03125 4.03125,4.03125c2.28438,0 4.03125,-1.74688 4.03125,-4.03125v-8.0625c0,-2.28437 -1.74687,-4.03125 -4.03125,-4.03125zM146.46875,77.9375c-2.28438,0 -4.03125,1.74688 -4.03125,4.03125v8.0625c0,2.28437 1.74687,4.03125 4.03125,4.03125c2.28438,0 4.03125,-1.74688 4.03125,-4.03125v-8.0625c0,-2.28437 -1.74687,-4.03125 -4.03125,-4.03125zM107.63385,89.12317c-1.59911,0.07716 -3.82916,0.85769 -6.8526,2.92371c-2.28437,1.6125 -6.44947,-1.7474 -8.19635,0.80572c-1.74688,2.41875 7.25572,9.67448 10.21197,8.19635c5.10625,-2.41875 8.3302,-7.38905 8.3302,-9.13593c0.08398,-1.0918 -0.82803,-2.91846 -3.49323,-2.78986zM25.53125,102.125c-9.675,0 -17.46875,7.79375 -17.46875,17.46875c0,9.675 7.79375,17.46875 17.46875,17.46875c9.675,0 17.46875,-7.79375 17.46875,-17.46875c0,-9.675 -7.79375,-17.46875 -17.46875,-17.46875zM146.46875,102.125c-9.675,0 -17.46875,7.79375 -17.46875,17.46875c0,9.675 7.79375,17.46875 17.46875,17.46875c9.675,0 17.46875,-7.79375 17.46875,-17.46875c0,-9.675 -7.79375,-17.46875 -17.46875,-17.46875zM25.53125,110.1875c5.24062,0 9.40625,4.16562 9.40625,9.40625c0,5.24063 -4.16563,9.40625 -9.40625,9.40625c-5.24063,0 -9.40625,-4.16562 -9.40625,-9.40625c0,-5.24063 4.16562,-9.40625 9.40625,-9.40625zM146.46875,110.1875c5.24062,0 9.40625,4.16562 9.40625,9.40625c0,5.24063 -4.16563,9.40625 -9.40625,9.40625c-5.24062,0 -9.40625,-4.16562 -9.40625,-9.40625c0,-5.24063 4.16563,-9.40625 9.40625,-9.40625zM52.00208,131.05237c-1.30176,0.09973 -2.55103,0.8031 -3.2229,1.97888c-1.075,1.88125 -0.40365,4.43385 1.4776,5.50885l6.98645,4.03125c0.67188,0.40312 1.34375,0.53802 2.01563,0.53802c1.34375,0 2.68698,-0.67187 3.49323,-2.01562c1.075,-1.88125 0.40365,-4.43385 -1.4776,-5.50885l-6.98645,-4.03125c-0.70547,-0.40312 -1.5049,-0.56112 -2.28595,-0.50128zM119.99792,131.05237c-0.78105,-0.05984 -1.58048,0.09816 -2.28595,0.50128l-6.98645,4.03125c-1.88125,1.075 -2.5526,3.6276 -1.4776,5.50885c0.80625,1.34375 2.14948,2.01563 3.49323,2.01563c0.67188,0 1.34375,-0.1349 2.01563,-0.53802l6.98645,-4.03125c1.88125,-1.075 2.5526,-3.6276 1.4776,-5.50885c-0.67187,-1.17578 -1.92114,-1.87915 -3.2229,-1.97888zM86,135.71875c-9.675,0 -17.46875,7.79375 -17.46875,17.46875c0,9.675 7.79375,17.46875 17.46875,17.46875c9.675,0 17.46875,-7.79375 17.46875,-17.46875c0,-9.675 -7.79375,-17.46875 -17.46875,-17.46875zM86,143.78125c5.24063,0 9.40625,4.16563 9.40625,9.40625c0,5.24062 -4.16562,9.40625 -9.40625,9.40625c-5.24062,0 -9.40625,-4.16563 -9.40625,-9.40625c0,-5.24062 4.16563,-9.40625 9.40625,-9.40625z"></path>
              </g>
            </g>
          </svg>
          <h1 class="h1-seo" style="color: white">IT CONSULTING</h1>
          <h3 style="color: white">Get the right expertise from certified IT consultants</h3>
        </div>
        <!--        <h6 class="category category-absolute">-->
        <!--          Designed by-->
        <!--          <a href="http://invisionapp.com/" target="_blank">-->
        <!--            <img src="img/invision-white-slim.png" class="invision-logo" /> </a-->
        <!--          >. Coded by-->
        <!--          <a href="https://www.creative-tim.com" target="_blank">-->
        <!--            <img-->
        <!--              src="img/creative-tim-white-slim2.png"-->
        <!--              class="creative-tim-logo"-->
        <!--            /> </a-->
        <!--          >.-->
        <!--        </h6>-->
      </div>
    </div>


    <a name="services"></a>
    <div class="main">
      <div class="section" style="margin-bottom: -4em;">
        <div class="container">
          <div class="uk-child-width-expand@s uk-text-center" uk-grid>
            <div>
              <!--              <div class="uk-card uk-card-default uk-card-body">Item</div>-->
              <div class="uk-card uk-card-default uk-card-body" uk-scrollspy="cls: uk-animation-scale-up; repeat: true">
                <div><img src="svg/pale-delivery-4.svg" alt="" style="margin-bottom: 1.8em;"/></div>
                <h5>
                  <span class="inline-icon" uk-icon="icon: settings; ratio: 0.8"></span>
                  IT Planning and Deployment
                </h5>
                <p class="bfs-font-size-medium" style="margin-bottom: 1.5em">
                  From auditing your current situation to helping you plan your future IT investments. Our team can help
                  you in all aspects of your IT challenges.
                </p>
              </div>
            </div>
            <div>
              <div class="uk-card uk-card-default uk-card-body" uk-scrollspy="cls: uk-animation-scale-up; repeat: true">
                <img src="svg/pale-woman-works-with-computer.svg" style="margin-top: -2em" alt=""/>
                <h5><span class="inline-icon" uk-icon="icon: lock; ratio: 0.8"></span> Confidence and Impartiality</h5>
                <p class="bfs-font-size-medium">
                  We work for our clients, not for the vendors we represent. Our approach is based on answering
                  your specific business needs by leveraging the best solutions in the market.</p>
              </div>
            </div>
            <div>
              <div class="uk-card uk-card-default uk-card-body" uk-scrollspy="cls: uk-animation-scale-up; repeat: true">
                <img src="svg/pale-businessman-at-the-office.svg" alt="" style="margin-bottom: 2.5em"/>
                <h5><span class="inline-icon" uk-icon="icon: cloud-upload; ratio: 0.8"></span> Certified Expertise</h5>
                <p class="bfs-font-size-medium">
                  We've been working with companies of all sizes and best-in-class manufacturers for years, we are
                  certified in IT consulting services and solutions that we develop and deploy for you.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="container">
        <hr class="uk-divider-icon">
        <div class="uk-child-width-expand@s uk-text-left">
          <div>
            <div>
              <!-- Category link -->
              <!--                    <span class="uk-label uk-label-success">-->
              <!--                  <nuxt-link :to="{ name: 'categories-id', params: { id: c.id } }"-->
              <!--                             class="uk-link-reset"> {{ c.name }}-->
              <!--                  </nuxt-link>-->
              <!--              </span>-->


              <div class="uk-card uk-card-default uk-card-body text-center bfs-colored-card"
                   uk-scrollspy="cls: uk-animation-slide-right; repeat: true">

                <span uk-icon="icon: server; ratio: 1.5" class="inline-icon"></span>
                <p class="bfs-font-size-medium">
                  Our IT consulting services are at the core of everything we do. We
                  work closely with our clients to understand and define their specific business needs,
                  in order to develop tailored solutions that meet the desired business objectives.
                </p>
              </div>

              <div class="uk-card uk-card-default uk-card-body text-center"
                   uk-scrollspy="cls: uk-animation-slide-left; repeat: true">
                <span uk-icon="icon: cog; ratio: 1.5" class="inline-icon"></span>
                <p class="bfs-font-size-medium">
                  From designing your IT infrastructure to helping you in the planning and
                  budgeting of your IT needs for the years to come, our consultants are able to find a solution for just
                  about any IT-related
                  issue or challenge.
                </p>
              </div>

              <div class="uk-card uk-card-default uk-card-body text-center bfs-colored-card"
                   uk-scrollspy="cls: uk-animation-slide-left; repeat: true">
                <span uk-icon="icon: world; ratio: 1.5" class="inline-icon"></span>
                <p class="bfs-font-size-medium">
                  Our team of professionals is dedicated to the success of our clients and
                  will work tirelessly to develop the right IT consulting solutions to help your organization in
                  Toronto and across Canada.
                </p>
              </div>

              <div class="uk-card uk-card-default uk-card-body text-center"
                   uk-scrollspy="cls: uk-animation-slide-left; repeat: true">
                <span uk-icon="icon: cloud-download; ratio: 1.5" class="inline-icon"></span>
                <p class="bfs-font-size-medium">
                  We will provide you an integrated Software Application Development solution based on your specific
                  requirements.
                  We combine business domain knowledge with technology competence and proven methodologies to deliver
                  high quality results in a cost-effective manner to maximize your competitive advantage and
                  productivity.
                </p>
              </div>

            </div>
          </div>
        </div> <!-- Grid right column -->
      </div>

    </div>

    <div class="section section-thin">
      <div class="container">


      </div>

    </div>

    <section>
      <div class="container">
            <h4 class="title text-center">Why Work With Us?</h4>
        <div class="uk-child-width-expand@s uk-text-left">
          <div class="uk-card uk-card-default uk-card-body"
               uk-scrollspy="cls: uk-animation-slide-left; repeat: true">
            <ul>
              <li> Proactive managed IT consulting services – from complete IT infrastructure to backups, automation,
                and functions
              </li>
              <li> Practical provider of help desk services to organizations seeking comprehensive or fully outsourced
                solutions
              </li>
              <li> Cross-functional cloud assessment, migration, and disaster recovery from IT consultancy in Toronto
              </li>
              <li> Comprehensive IT management consulting, staff augmentation, direct or contract services</li>
              <li> Effective IT consulting services for cabling and wiring, network assessment, and major application
                implementations
              </li>
              <li> Save time and money with IT consulting services in Toronto.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>


    <a name="contact"></a>
    <div class="section">
      <div class="container text-center">
        <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
            <h4 class="title">Contact Us</h4>
              <p class="description"> Email: info@signitive.ca</p>
          </div>
        </div>
      </div>
    </div>
    <!--    <contact-form></contact-form>-->
  </div>
</template>
<script>
import {Parallax} from '@/components';
import BasicElements from './components/BasicElementsSection';
import Navigation from './components/Navigation';
import TabsSection from './components/Tabs';
import ProgressPagination from './components/ProgressPagination';
import Notifications from './components/Notifications';
import Typography from './components/Typography';
import JavascriptComponents from './components/JavascriptComponents';
import CarouselSection from './components/CarouselSection';
import NucleoIconsSection from './components/NucleoIconsSection';


import ContactForm from "@/pages/ContactForm";
import SignupForm from './components/SignupForm';
import ExamplesSection from './components/ExamplesSection';
import DownloadSection from './components/DownloadSection';

export default {
  name: 'index',
  bodyClass: 'index-page',
  components: {
    Parallax,
    BasicElements,
    Navigation,
    TabsSection,

    ContactForm

    // ProgressPagination,
    // Notifications,
    // Typography,
    // JavascriptComponents,
    // CarouselSection,
    // NucleoIconsSection,
    // // SignupForm,
    // ExamplesSection,
    // DownloadSection
  }
};
</script>
<style>

.inline-icon {
  margin: 5px;
}

.bfs-font-size-medium {
  font-size: medium;
}

.bfs-colored-card {
  background: #e57373;
  color: whitesmoke;
}
</style>
